<script setup lang="ts">
import { AssistantTool } from "@/types/ai-chat.types";

export type Props = {
  app: AssistantTool;
};
const { t } = useI18n();
defineProps<Props>();
const emit = defineEmits(["change"]);
</script>
<template>
  <div class="enabled-tools__item">
    <div class="enabled-tools__content">
      <div class="enabled-tools__icon">
        <i :class="`bi bi-${app.icon}`"></i>
      </div>
      <div class="enabled-tools__title">
        {{ t(`aiChat.aiAssistant.tools.${app.id}`) }}
        <span v-if="app.experimental" class="ms-1">🤓</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.enabled-tools {
  &__item {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__content {
    display: flex;
    align-items: center;
    flex: 1 1;
    gap: $spacer-2;
    padding: $btn-padding-y $spacer-2;
    color: $secondary;
    background-color: $color-white;
    border: 1px solid $border-color;
    border-radius: $border-radius-lg;
    box-shadow: $shadow-brand;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__icon {
    display: flex;
    place-self: center center;
    padding: $spacer-1 $spacer-2;
    background-color: $hover-color;
    border-radius: $border-radius-sm;
  }

  &__title {
    font-size: $font-size-sm;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
